import React from 'react'
import { Link } from 'react-router-dom'

function DetailsHeaderBar({title, subtitle, breadcrumbs = []}) {
  return (
    <div className="details-header">
        {/* Title and Subtitle */}
        <div>
            <h2 style={{width:"330px"}}>{title}</h2>
            <p>{subtitle}</p>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
            {breadcrumbs.map((item, index) => (
            <span key={index}>

                {item.path ? (
                <Link to={item.path} className="breadcrumb-link">
                    {item.label}
                </Link>
                ) : (
                <span className="breadcrumb-current">{item.label}</span>
                )}

                {index < breadcrumbs.length - 1 && (
                <span className="breadcrumb-separator">{">"}</span>
                )}
            </span>
            ))}
        </div>
    </div>
  )
}

export default DetailsHeaderBar